<button class="floating-back" (click)="goBack()" aria-label="Go back">
  <span class="halo"></span>
  <ion-icon name="arrow-back-outline"></ion-icon>
</button>
